import { render } from "./AppRichTextEditorField.vue?vue&type=template&id=95493d0a&scoped=true"
import script from "./AppRichTextEditorField.vue?vue&type=script&lang=js"
export * from "./AppRichTextEditorField.vue?vue&type=script&lang=js"

import "@/assets/scss/domains/app/components/common/_app-rich-text-editor-field.scss?vue&type=style&index=0&id=95493d0a&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95493d0a"]])

export default __exports__